export const getGuidelineData = (state, id) => {
    return state?.guidelines?.[id] || null;
};

export const getEventGuidelineFetching = state => state.guidelines.singleFetching;
